var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_13754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 6.875V17.2451C8.93743 17.3581 8.90948 17.4695 8.85611 17.5691C8.80275 17.6688 8.72562 17.7538 8.63156 17.8166L7.68625 18.4465C7.59456 18.5076 7.48951 18.5458 7.37997 18.5579C7.27042 18.5699 7.15959 18.5554 7.05681 18.5156C6.95403 18.4759 6.86231 18.412 6.78939 18.3294C6.71647 18.2467 6.66449 18.1478 6.63781 18.0409L5.5 13.75",
    stroke: "#858584",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 17.1875C19.25 17.3184 19.2126 17.4466 19.1421 17.557C19.0717 17.6674 18.9713 17.7554 18.8526 17.8106C18.7339 17.8658 18.6019 17.886 18.4721 17.8688C18.3423 17.8516 18.2201 17.7977 18.1199 17.7134C13.6168 13.9356 8.9375 13.75 8.9375 13.75H5.5C4.58832 13.75 3.71398 13.3878 3.06932 12.7431C2.42466 12.0985 2.0625 11.2241 2.0625 10.3125C2.0625 9.40077 2.42466 8.52643 3.06932 7.88178C3.71398 7.23712 4.58832 6.87496 5.5 6.87496H8.9375C8.9375 6.87496 13.6168 6.68933 18.1199 2.91238C18.2201 2.82814 18.3422 2.77423 18.4719 2.75698C18.6016 2.73973 18.7335 2.75985 18.8522 2.81499C18.9709 2.87013 19.0713 2.95799 19.1418 3.06826C19.2123 3.17852 19.2498 3.3066 19.25 3.43746V17.1875Z",
    stroke: "#858584",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_13754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "matrix(-1 0 0 1 22 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/Announcement.1eaecff8aec53667c96d80442e188545.svg";
export { ForwardRef as ReactComponent };